import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconChevron(props: SvgIconProps) {
  return (
    <SVGIcon width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1 1L7 7L1 13" stroke="currentColor" strokeWidth="1.5" />
    </SVGIcon>
  );
}
